var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":require("@/assets/img/404.svg"),"alt":"Not Found"}})
}
var staticRenderFns = []

export { render, staticRenderFns }